// @flow
import ElJurGoTo from './ElJurGoTo';

export default ElJurGoTo;
